var render, staticRenderFns
import script from "./GTimelineItemEmail.vue?vue&type=script&lang=ts&"
export * from "./GTimelineItemEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb3ff2",
  null
  
)

export default component.exports